import { createContext } from "react";

export const EstimateEditorStoreContext = createContext(null);